var keyMirror = require('keymirror');

module.exports = keyMirror({
	STEP_COMPLETE: null,
	STEP_GET_STARTED: null,
	STEP_SELECT: null,
	STEP_NEXT: null,
	STEP_SKIP: null,
	SITE_SET_TITLE: null,
	SITE_SET_TYPE: null,
	SITE_SET_DESCRIPTION: null,
	SITE_ADD_BUSINESS_ADDRESS: null,
	SITE_INSTALL_WOOCOMMERCE: null,
	SITE_INSTALL_WOOCOMMERCE_SUCCESS: null,
	SITE_INSTALL_WOOCOMMERCE_FAIL: null,
	SITE_REDIRECT_TO_WOOCOMMERCE_SETUP: null,
	SITE_SAVE_TITLE_AND_DESCRIPTION: null,
	SITE_CONTACT_PAGE_ID: null,
	SITE_SET_THEME: null,
	SITE_INSTALL_THEME: null,
	SITE_JETPACK_CONFIGURED: null,
	SITE_JETPACK_MODULE_ENABLED: null,
	SITE_JETPACK_MODULE_DISABLED: null,
	SITE_JETPACK_JUMPSTART_ENABLED: null,
	SITE_JETPACK_ADD_MODULES: null,
	SITE_SET_LAYOUT: null,

	SITE_CREATE_CONTACT_US_PAGE: null,
	SITE_CREATE_LAYOUT_PAGES: null,

	SAVE_STARTED: null,
	SAVE_FINISHED: null,

	SET_FLASH: null,
	UNSET_FLASH: null,
	FLASH_SEVERITY_NOTICE: null,
	FLASH_SEVERITY_ERROR: null,

	RESET_DATA: null,

	SHOW_SPINNER: null,
	HIDE_SPINNER: null
});



// WEBPACK FOOTER //
// ./client/constants/jetpack-onboarding-constants.js